import { requestWithAbort } from '@atlassian/twg-common';

export type CollabGraphRecommendedEntity = {
	id: string;
	score: number;
	expand: {
		ari: string;
		account_id: string;
		email: string;
		name: string;
		picture: string;
		// There may be extra things returned
	};
};

export type CollabGraphResponse = {
	recommendedEntities: CollabGraphRecommendedEntity[];
};

export type RequestCollaborationUsersInput = {
	requestingUserId: string;
	targetUserId: string;
	tenantId: string;
	limit: number;
};

/**
 * See docs: https://developer.atlassian.com/platform/collaboration-graph/rest/api-group-collaboration-graph-recommendations-api/#api-v2-recommend-user-post
 */
export const requestCollaborationUsers = ({
	requestingUserId,
	targetUserId,
	tenantId,
	limit,
}: RequestCollaborationUsersInput): ReturnType<typeof requestWithAbort<CollabGraphResponse>> => {
	const body = {
		modelRequestParams: {
			experience: 'CgUserNearbyUser',
			caller: 'twg-microsite',
			featureServiceModel: 'cg_user_user_v5',
		},
		expand: 'all',
		requestingUserId,
		context: {
			userId: targetUserId,
			tenantId,
		},
		maxNumberOfResults: limit,
	};

	return requestWithAbort<CollabGraphResponse>(
		'post',
		`/gateway/api/collaboration/v2/recommend/user`,
		body,
		{
			credentials: 'include',
		},
	);
};
